import {
  Button,
  CardActions,
  CardContent,
  CardMedia,
  Card,
  Avatar,
  Chip,
} from "@mui/material";
import moment from "moment";

import React, { useEffect, useState } from "react";
import { AiFillClockCircle } from "react-icons/ai";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { MdOutlineError } from "react-icons/md";

import { useNavigate } from "react-router-dom";
import Constants from "../data/Constants";
import BillingDialog from "./BillingDialog";

function OrderItem(props) {
  const { item, onClick, className } = props;
  const [billingDialog, setBillingDialog] = useState(false);

  return (
    item && (
      <Card sx={{}} className={className} onClick={onClick}>
        <div className="">
          <div className="flex p-4 gap-4">
            <div className="flex items-center mx-4">
              {item.status == "SUCCESS" && (
                <BsFillCheckCircleFill size={60} className="text-green-500" />
              )}
              {item.status == "FAILED" && (
                <MdOutlineError size={60} className="text-red-500" />
              )}

              {item.status == "PENDING" && (
                <AiFillClockCircle size={60} className="text-yellow-500" />
              )}
            </div>
            <div>
              <h1 className="font-bold uppercase">
                Order
                {item.status == "SUCCESS" && " Successfull"}
                {item.status == "FAILED" && " Failed"}
                {item.status == "PENDING" && " Pending"}
              </h1>
              <h1 className="text-sm">
                Order ID: <b>{item.orderNumber}</b>
              </h1>
              <h1 className="text-sm">
                Total Amount: {Constants.CURRENCY_SYMBOL + item.totalAmount}
              </h1>
              <h1 className="text-sm">
                Paid Amount: {Constants.CURRENCY_SYMBOL + item.payableAmount}
              </h1>
              <h1 className="text-sm">
                Discount Amount:{" "}
                {Constants.CURRENCY_SYMBOL + item.discountAmount}
              </h1>
              <h1 className="text-sm">
                Created At:{" "}
                {moment(item.createdAt).format(Constants.DATE_TIME_FORMAT)}
              </h1>

              {item.status == "FAILED" && (
                <>
                  Reason: <b>{item.payment.razorpay.error.description}</b>
                </>
              )}
              <h1 className="text-sm my-2">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    setBillingDialog(true);
                  }}
                >
                  View Billing
                </Button>
              </h1>
            </div>
          </div>
          <h1 className="text-sm mx-4">Bought Items:</h1>
          <div className="flex gap-2 m-2 overflow-scroll">
            {item.courses.map((courseObj) => {
              return (
                <Chip
                  label={
                    courseObj.course.name +
                    (courseObj.courseClass
                      ? " • BATCH " + courseObj.courseClass.batchNumber
                      : "")
                  }
                />
              );
            })}
            {item.counselling.map((courseObj) => {
              return (
                <Chip
                  label={
                    courseObj.mentor.firstname + " " + courseObj.mentor.lastname
                  }
                />
              );
            })}
          </div>
        </div>
        <BillingDialog
          open={billingDialog}
          data={item.billing}
          onClose={() => {
            setBillingDialog(false);
          }}
        />
      </Card>
    )
  );
}

export default OrderItem;
